import React from "react";
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import './HomeBanner.css';

// --- DATA ---
// Updated to a single image for the first slide

const slide1Desktop = 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2FIMG_4668%202.webp?alt=media&token=b420f6b8-7e59-447e-9501-93fcd71b8727';
const slide1Mobile = 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2FIMG_4668%202.webp?alt=media&token=b420f6b8-7e59-447e-9501-93fcd71b8727';

const slide2Desktop = 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2FBanner_2.webp?alt=media&token=6651c932-9089-4466-848c-7c1b87fd4822';
const slide2Mobile = 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2FIMG_5232.webp?alt=media&token=bb6792da-88a1-453d-b417-9d63ade215b5';

const slide3Desktop = 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2Fbanner.webp?alt=media&token=8d6c3d16-27fa-45cb-be3e-d3c09258ec17';
const slide3Mobile = 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2Fbanner%20(1).webp?alt=media&token=de36771b-a4ef-4878-bea4-edde798d99d4';

// --- ARROW COMPONENTS (Keep these as they are) ---
const NextArrow = ({ className, style, onClick }) => (
  <button className={className} style={{ ...style, display: 'block' }} onClick={onClick} aria-label="Next slide">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </button>
);

const PrevArrow = ({ className, style, onClick }) => (
  <button className={className} style={{ ...style, display: 'block' }} onClick={onClick} aria-label="Previous slide">
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </button>
);

const HomeBanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="HomeBannerSection">
      <Slider {...settings}>

        {/* Slide 1: Single Image (Simplified) */}
        <div className="item banner-slide-item">
          <Link to="/category/new-arrivals" aria-label="Shop New Arrivals">
            <picture>
              <source media="(max-width: 768px)" srcSet={slide1Mobile} />
              <img
                src={slide1Desktop}
                alt="New Arrival Collection"
                width="1440"
                height="800"
                fetchPriority="high"  // <--- This is crucial for LCP
                loading="eager"       // <--- Never lazy load the hero image
                style={{ width: '100%', display: 'block', objectFit: 'cover' }}
              />
            </picture>
          </Link>
        </div>

        {/* Slide 2: Full-width slide (Switching logic remains) */}
        <div className="item banner-slide-item">
          <Link to="/accessories" aria-label="Shop New Arrivals">
            <picture>
              <source media="(max-width: 768px)" srcSet={slide2Mobile} />
              <img
                src={slide2Desktop}
                alt="New Arrival Collection"
                width="1440"
                height="800"
                style={{ width: '100%', display: 'block', objectFit: 'cover' }}
              />
            </picture>
          </Link>
        </div>

        {/* Slide 3: Full-width slide (Switching logic remains) */}
        <div className="item banner-slide-item">
          <Link to="/shop-all" aria-label="Shop New Arrivals">
            <picture>
              <source media="(max-width: 768px)" srcSet={slide3Mobile} />
              <img
                src={slide3Desktop}
                alt="New Arrival Collection"
                width="1440"
                height="800"
                style={{ width: '100%', display: 'block', objectFit: 'cover' }}
              />
            </picture>
          </Link>
        </div>

      </Slider>
    </section>
  );
};

export default HomeBanner;